// mini cart
var apimonycount = 0;
$(document).ready(function() {

    PROJ.ajaxcart.init();
    PROJ.pdp.init();

    $( '.ac-title:not(.active)').each(function(){
        $(this).next().css('display','none');
    });

    $('body').on('click', '.ac-title', function (e) {

        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            $(this).next().removeClass('active');
            $(this).next().slideUp();
        }
        else {
            $(this).next().addClass('active');
            $(this).next().slideDown();
        }
        $(this).toggleClass('active');

    });

    // get querystring
    var name = GetParameterValues('viewcart');
    function GetParameterValues(param) {
        var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < url.length; i++) {
            var urlparam = url[i].split('=');
            if (urlparam[0] == param) {
                return urlparam[1];
            }
        }
    }
    if(name)
    {
        PROJ.ajaxcart.opencart();
    }

});


"use strict"
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;
        // _this.updateCart();
        _this.giftwrap();


        $('body').on('click', '.nav-close-cart, .minicart-back', function (e) {
            e.preventDefault();
            _this.closecart();
        });

        $('body').on('click tap', '.close-upsell,.upsell-overlay', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.opencart();
            _this.closeupsell();
        });

        $('body').on('click tap', 'a.mini_cart, .cart-open, [href="/cart"]:not(.btn)', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.opencart();
            _this.closeupsell();
        });

        $('body').on('click', '[data-varid]', function (e) {
            e.preventDefault();
            var varid = $(this).attr('data-varid');
            $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
            $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
            $(this).addClass('active');
        });


        //activate free gift with chkecnbox

        $('body').on('change', '#fgifts', function (e) {
            if(this.checked) {
                $('.free-items-box .dum').hide();
                $('.free-items-box .org').show();
            }else
            {
                $('.free-items-box .dum').show();
                $('.free-items-box .org').hide();
            }
        });


        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
            //$('body,html').removeClass('upsell-cart');
            //$('body,html').removeClass('upsell-cart-ani');

            //PROJ.upsells.closequickbuy();


        });

        $('body').on('click', '.qty-step-btn', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = par.attr('data-count');
            if ($(this).find('.icon-minus').length) {
                qty--;
                if (qty < 0) qty = 0;
            }
            else {
                qty++;
            }
            par.attr('data-count',qty);
            par.find('.qty-step-count').text(qty);
            _this.updateItem(par.attr('data-proid'), qty);

            setTimeout(function(){
                if($('body').hasClass('template-cart'))
                {
                    location.reload(true);
                }
            },500);
        });

        $('body').on('click', '.buy-wrap .QuantitySelector__Button', function (e) {
            e.preventDefault();
            var par = $(this).parents('.buy-wrap').find('.QuantitySelector__CurrentQuantity');
            var qty = parseInt(par.val());
            if ($(this).hasClass('min'))
            {
                qty--;
                if(qty < 1) qty = 1;
            }
            else {
                qty++;
            }
            par.val(qty)
        });

        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });



        $('body').on('click', '.upsell-replace', function (e) {
            var upsellid = "";
            e.preventDefault();
            e.stopPropagation();
            $('#shopify-section-upsells .ajax_loader').addClass('active');
            var productid = $('[data-product-select]').attr('data-product-select');
            if(upsellid == "")
            {
                upsellid = $(this).attr('data-upsell-id');
            }

            var datas = "updates[" + productid + "]=" + 0 + "&";
            datas += "updates[" +upsellid+ "]=" + 1 + "&";

            // Add to cart.
            jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: datas,
                dataType: 'json',
                success: function () {
                    PROJ.ajaxcart.updateCart();
                    $('#shopify-section-upsells .ajax_loader').removeClass('active');
                    $('body,html').removeClass('upsell-cart-ani');
                    $('body,html').addClass('mini-cart');
                    setTimeout(function(){
                        $('body,html').addClass('mini-cart-ani');
                        $('body,html').removeClass('upsell-cart');

                    },500);
                }
            });

        });

        $('body').on('submit', 'form[action="/cart/add"]', (function (e) {

            e.preventDefault();
            var $addToCartForm = $(this);
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    _this.updateCart();
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                    if($('.upsell-single-wrap').length)
                    {
                        _this.openupsell();
                    }else
                    {
                        _this.opencart();
                    }
                },
                error: function (XMLHttpRequest) {
                    _this.updateCart();

                }
            });
            return false;

        }));

        $(window).resize(function () {

            _this.resizecart();
        });
        $(window).resize(function () {
            PROJ.ajaxcart.resizecart();
        });
        setTimeout(function(){
            PROJ.ajaxcart.resizecart();
        },1000);


    },resizecart:function(){
        var maxh = $(window).height()-80;
        $('.ajax_place').css('max-height',maxh+"px");
        $('.mini-body').height($('#shopify-section-mini-cart').height() - $('.checkout-se').height() - 10);
        //$('#mini-cart .mini-body').css('max-height',$(window).height() - ($('.checkout-se').height() + 70 + $('.sell-note').height()));
    },

    updateCart: function () {
        var _this = this;
        $('body,html').removeClass('mini-cart-ani');
        $.get("/cart?view=mini", function (data) {

            $('#mini-cart .ajax_place').html($(data));

            var counti = $('[data-icount]').attr('data-icount');



            counti==0? $('.Header__CartCount').text('0'): $('.Header__CartCount').text(counti);



        }).done(function (cart) {

            $('#mini-cart').removeClass('loading');
            PROJ.ajaxcart.resizecart();
            // _this.charity();

            //check for product limit

            if($('#mini-cart [data-limit]').length)
            {
                $('#mini-cart [data-limit]').each(function(){
                    var limit = parseInt($(this).attr('data-limit'));
                    if(parseInt($(this).attr('data-count'))>limit)
                    {
                        _this.updateItem($(this).attr('data-proid'), limit);
                    }

                });
            }

            $('body,html').addClass('mini-cart-ani');

        });
    },

    addItem: function (id) {
        var _this = this;

        if(!$('body').hasClass('upsell-cart'))
        {
            $('#mini-cart').addClass('loading');
            $('body,html').addClass('mini-cart');
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                if(!$('body').hasClass('upsell-cart'))
                {
                    _this.updateCart();
                }else
                {
                    PROJ.upsells.opencart();
                    PROJ.upsells.closequickbuy();
                    _this.updateCart();
                }

            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
                if($('body').hasClass('upsell-cart'))
                {
                    PROJ.upsells.opencart();
                }
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },

    giftwrap: function () {
        var _this = this;
        $('body').on('keyup','#gift-note', function (e) {
            var count = $(this).val().length;
            var max = $(this).attr('maxlength');
            $(this).next().html("<strong>"+(max - count) +"</strong>"+ " Characters Remaining");
        });

        $('body').on('click','.gift-wrap-panel .all-close-cart, .gift-wrap-panel .cancel', function (e) {
            $('.gift-wrap-panel ').removeClass('active');
        });
        $('body').on('click','.gift-wrap-box .propose', function (e) {
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                var gid = $('[data-gift-id]').attr('data-gift-id');
                $('#mini-cart').addClass('loading');
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=0&attributes[gift-note]="+encodeURIComponent(''),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $('.gift-wrap-panel ').addClass('active');
            }
        });
        $('body').on('click','.gift-wrap-box .edit', function (e) {
            $('.gift-wrap-panel ').addClass('active');
        });
        $('body').on('click','[data-gift-id]', function (e) {
            e.preventDefault();
            var gid = $(this).attr('data-gift-id');
            $('#mini-cart').addClass('loading');
            if($('.gift-wrap-wrap').hasClass('activegift'))
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }else
            {
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates["+gid+"]=1&attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
                    dataType: "json",
                    success: function (t) {
                        _this.updateCart();
                    },
                    error: function (t, r) {
                        _this.updateCart();
                    }
                });
            }

        });


    },

    opencart: function () {
        $('body,html').addClass('mini-cart');
        setTimeout(function(){
            $('body,html').addClass('mini-cart-ani');
        },500);
    },
    closecart: function () {
        $('body,html').removeClass('mini-cart')
        setTimeout(function(){
            $('body,html').removeClass('mini-cart-ani');
        },500);
    },
    openupsell: function () {
        $('body,html').addClass('upsell-cart-ani');
        setTimeout(function(){
            $('body,html').addClass('upsell-cart');
        },500);
    },
    closeupsell: function () {
        $('body,html').removeClass('upsell-cart');
        setTimeout(function(){
            $('body,html').removeClass('upsell-cart-ani');
        },500);
    }


};
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    init: function () {
        var _this = this;
        $('body').on('click', '.option-wrap .variable',function (e){
            e.preventDefault();
            if($(this).hasClass('active')) return;
            var thisform = $(this).parents('.option-wrap');
            var thisid = $(this).attr('varid');

            thisform.find('.variable').removeClass('active');
            $(this).addClass('active');
            window.history.replaceState({ }, '', '?variant='+thisid);

            var varprice = $(this).parent().find('.var-price').html();
            $('.price-pdp .price').html(varprice);
            console.log(thisid);
            $('.ProductForm__Option select').val(thisid);

            if($(this).hasClass('available'))
            {
               $('#AddToCart').removeAttr('disabled');
               $('#AddToCart span').text('Add to cart');
            }else
            {
                $('#AddToCart').attr('disabled','');
                $('#AddToCart span').text('Sold out');
            }
            if($(this).attr('data-imgvar-id') != "")
            {

                var ind = $('#Image'+$(this).attr('data-imgvar-id')).index();
                $('.Product_Slides').flickity( 'select', ind );
            }
        });
    }
};
